import { IPublicClientApplication } from '@azure/msal-browser'
import { protectedResources } from '../authConfig'
import {
  AddDesignRequestMessage,
  DesignRequest,
  DesignRequestMessage,
} from '../models/DesignRequest'
import { authorizedGet, authorizedPost } from '../utils/authUtils'

const baseUrl = process.env.REACT_APP_BASE_API_URL

export async function fetchDesignRequests(
  instance: IPublicClientApplication,
  organizationId: number,
): Promise<DesignRequest[]> {
  return authorizedGet(
    instance,
    `${baseUrl}/designRequests/organization/${organizationId}`,
    protectedResources.scopes.read,
  )
}

export async function fetchDesignRequestById(
  instance: IPublicClientApplication,
  requestId: number,
): Promise<DesignRequest> {
  return authorizedGet(
    instance,
    `${baseUrl}/designRequests/${requestId}`,
    protectedResources.scopes.read,
  )
}

export async function approveDesignRequest(
  instance: IPublicClientApplication,
  requestId: number,
): Promise<void> {
  return authorizedPost(
    instance,
    `${baseUrl}/designRequests/${requestId}/approve`,
    {},
    protectedResources.scopes.read,
  )
}

export async function requestDesignChanges(
  instance: IPublicClientApplication,
  requestId: number,
  changes: string,
): Promise<DesignRequestMessage> {
  return authorizedPost(
    instance,
    `${baseUrl}/designRequests/${requestId}/requestChanges`,
    { changes },
    protectedResources.scopes.read,
  )
}

export async function sendDesignRequestMessage(
  instance: IPublicClientApplication,
  requestId: number,
  message: AddDesignRequestMessage,
): Promise<void> {
  return authorizedPost(
    instance,
    `${baseUrl}/designRequests/${requestId}/messages`,
    message,
    protectedResources.scopes.read,
  )
}
